export interface StatusMeta {
  label: string;
  classes: string;
  dot: string;
}

export const lessonStatusMap: Record<string, StatusMeta> = {
  planlandi: { label: 'Planlandı', classes: 'bg-primary-100 text-primary-700', dot: 'bg-primary-500' },
  islendi: { label: 'İşlendi', classes: 'bg-emerald-100 text-emerald-700', dot: 'bg-emerald-500' },
  iptal: { label: 'İptal', classes: 'bg-red-100 text-red-700', dot: 'bg-red-500' },
  ertelendi: { label: 'Ertelendi', classes: 'bg-orange-100 text-orange-700', dot: 'bg-orange-500' },
  kayit_yuklendi: { label: 'Kayıt Yüklendi', classes: 'bg-teal-100 text-teal-700', dot: 'bg-teal-500' },
};

export const recordStatusMap: Record<string, StatusMeta> = {
  yayinda: { label: 'Yayında', classes: 'bg-emerald-100 text-emerald-700', dot: 'bg-emerald-500' },
  taslak: { label: 'Taslak', classes: 'bg-secondary-100 text-secondary-700', dot: 'bg-secondary-500' },
};

export const assignmentStatusMap: Record<string, StatusMeta> = {
  gonderildi: { label: 'Gönderildi', classes: 'bg-primary-100 text-primary-700', dot: 'bg-primary-500' },
  goruldu: { label: 'Görüldü', classes: 'bg-amber-100 text-amber-700', dot: 'bg-amber-500' },
  teslim_edildi: { label: 'Teslim Edildi', classes: 'bg-emerald-100 text-emerald-700', dot: 'bg-emerald-500' },
  kontrol_edildi: { label: 'Kontrol Edildi', classes: 'bg-teal-100 text-teal-700', dot: 'bg-teal-500' },
  eksik: { label: 'Eksik', classes: 'bg-red-100 text-red-700', dot: 'bg-red-500' },
  yeniden: { label: 'Yeniden Yapılmalı', classes: 'bg-orange-100 text-orange-700', dot: 'bg-orange-500' },
};

export const submissionStatusMap: Record<string, StatusMeta> = {
  teslim_edildi: { label: 'Teslim Edildi', classes: 'bg-amber-100 text-amber-700', dot: 'bg-amber-500' },
  kontrol_edildi: { label: 'Kontrol Edildi', classes: 'bg-emerald-100 text-emerald-700', dot: 'bg-emerald-500' },
  eksik: { label: 'Eksik', classes: 'bg-red-100 text-red-700', dot: 'bg-red-500' },
  yeniden: { label: 'Yeniden Yapılmalı', classes: 'bg-orange-100 text-orange-700', dot: 'bg-orange-500' },
};

export const paymentStatusMap: Record<string, StatusMeta> = {
  odendi: { label: 'Ödendi', classes: 'bg-emerald-100 text-emerald-700', dot: 'bg-emerald-500' },
  kismi: { label: 'Kısmi Ödendi', classes: 'bg-orange-100 text-orange-700', dot: 'bg-orange-500' },
  bekliyor: { label: 'Bekliyor', classes: 'bg-amber-100 text-amber-700', dot: 'bg-amber-500' },
  gecikti: { label: 'Gecikti', classes: 'bg-red-100 text-red-700', dot: 'bg-red-500' },
};

export const priorityMap: Record<string, StatusMeta> = {
  yuksek: { label: 'Yüksek', classes: 'bg-red-100 text-red-700', dot: 'bg-red-500' },
  orta: { label: 'Orta', classes: 'bg-amber-100 text-amber-700', dot: 'bg-amber-500' },
  dusuk: { label: 'Düşük', classes: 'bg-secondary-100 text-secondary-700', dot: 'bg-secondary-500' },
};

export const packageTypeMap: Record<string, string> = {
  birebir: 'Birebir Ders',
  grup: 'Grup Dersi',
  kamp: 'Kamp',
  deneme: 'Deneme Dersi',
  abonelik: 'Aylık Abonelik',
};

export function getStatusMeta(
  value: string,
  map: Record<string, StatusMeta>,
): StatusMeta {
  return map[value] ?? { label: value, classes: 'bg-secondary-100 text-secondary-700', dot: 'bg-secondary-500' };
}